import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import { Logo, Close } from 'components';
import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

const Header = ({ title, link }) => {
  const navigate = useNavigate();
  return (
    <TitleAndLogoContainer>
      <div className={link ? 'close-button-div' : ''}>
        <Logo />
        {link && <Close handleClick={() => navigate(link)} />}
      </div>
      <h1>{title}</h1>
    </TitleAndLogoContainer>
  );
};

export default Header;

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

const TitleAndLogoContainer = styled.div`
  width: 100%;

  h1 {
    margin-top: 30px;
    margin-bottom: 60px;
    text-align: center;
    color: ${COLORS.blue};
    ${FONT_FAMILY.FontBold}

    @media ${deviceMin.mobileS} {
      ${FONTS.font14}
      margin: 15px 0 20px 0;
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font20}
      margin: 24px 0 35px 0;
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font20}
      margin: 14px 0 17px 0;
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font24}
      margin: 25px 0 50px 0;
    }
  }

  .close-button-div {
    ${FLEX_CONTAINER.FlexSpaceBetweenRow}
    width: 100%;

    .close-button {
      margin-right: -20px;
    }

    .logo {
      margin: 0 auto;
      padding-left: 22px;
    }

    img {
      @media ${deviceMax.laptopM} {
        width: 15px;
        height: 15px;
      }

      @media ${deviceMax.mobileS} {
        width: 10px;
        height: 10px;
      }
    }
  }

  .logo {
    text-align: center;
  }
`;
